<script>
    //exports
    export let data;
    export let align = data.blockAlignment;
    export let bg = data.blockBackgroundColor;
    //export let bgImage = data.storageSolutionsBackgroundImage[0].urls.optimizedImageUrls;
    export let customStyles = data.blockCustomStyles;
    export let classes = data.blockClasses;
    export let id = data.blockID;
    export let fontColor = data.blockFontColor;
</script>

<style>
    .transparentBG {
        background-color: rgba(255, 255, 255, .8);
        backdrop-filter: saturate(180%) blur(20px);
    }
</style>

<div 
    class="text-{align} {classes} relative overflow-hidden {bg === 'transparent' ? 'transparentBG' : ''}" 
    style="color: {fontColor}; {bg !== 'transparent' ? `background-color: ${bg}` : ''}" 
    id={id}>

    {#if data.storageSolutionsBackgroundImage.length > 0}
        <picture>
            <source
                srcset="{data.storageSolutionsBackgroundImage[0].urls.srcset}"
                sizes="100vw"
            />
            <img
                src="{data.storageSolutionsBackgroundImage[0].urls.src}"
                alt=""
                class="absolute top-0 left-0 z-0 object-cover w-full h-full"
                loading="lazy"
            />
        </picture>
    {/if}

    <div class="relative z-10">
        <slot></slot>
    </div>
</div>
